module.exports = __webpack_public_path__ + "static/media/image-cover-video.00203865.jpg";